import { createActions } from 'redux-actions'
import * as constants from '../constants'

export default createActions({
  [constants.LAST_UPDATED]: updates => ( updates ),
  [constants.RESET_UPDATED]: null,
});
